import { useCallback, useEffect, useRef } from 'react';
import useMediaState from '@/common/hooks/useMediaState';
import { MediaState } from '@/types/types';
import { getCookie } from "cookies-next";
import { API_AUTH_COOKIE_NAME } from "@/enum/cookie.name.enum";
import useUniqueTabId from "@/common/hooks/useUniqueTabId";
import useAudioAdapter from "@/common/hooks/useAudioAdapter.ts";
import useCurrentTrack from "@/common/hooks/useCurrentTrack.ts";
import { userEventPlayingTrack } from "@/services/api/track.ts";
import useSessionUser from "@/common/hooks/useSessionUser.ts";
import useAudioEditorPeaksInstance from "@/common/hooks/useAudioEditorPeaksInstance.ts";
import { useSite } from "@/client/provider/site-context-provider.tsx";

const useUserEventPlayingTrack = () => {
  const site = useSite();
  const user = useSessionUser();
  const [uniqueTabId] = useUniqueTabId();
  const [audioAdapter] = useAudioAdapter();
  const [peaksInstance] = useAudioEditorPeaksInstance()
  const currentTrack = useCurrentTrack()
  const [mediaState] = useMediaState();
  const jsonWebToken = getCookie(API_AUTH_COOKIE_NAME) as string;
  const playedTracksByUser = useRef<Record<string, string>>({});

  const handleUserEventPlayingTrack = useCallback(() => {
    if (currentTrack && user && jsonWebToken) {
      const userId = user.id.toString();
      const currentTrackIdForUser = playedTracksByUser.current[userId];
      if (currentTrackIdForUser !== currentTrack?.explorerItemId) {

        /*sendWebPush({
          title: `Incoming message from ${site.siteName}`,
          message: `${user.firstName || user.email} is listening to: ${currentTrack.name}`,
        });*/

        userEventPlayingTrack(currentTrack.explorerItemId, user, uniqueTabId);

        // Update de track.id voor deze user.id in de useRef
        playedTracksByUser.current[userId] = currentTrack?.explorerItemId;
      }
    }
  }, [
    currentTrack,
    jsonWebToken,
    site.siteName,
    uniqueTabId,
    user
  ]);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout | null = null;

    const handleTimeUpdate = () => {
      const audioElement = audioAdapter?.mediaElement;
      if (!audioElement || mediaState !== MediaState.PLAYING) return;

      if (!timeoutId) {
        timeoutId = setTimeout(handleUserEventPlayingTrack, 1000);
      }
    };

    if (audioAdapter && currentTrack && mediaState === MediaState.PLAYING) {
      peaksInstance?.on('player.timeupdate', handleTimeUpdate);

      return () => {
        peaksInstance?.off('player.timeupdate', handleTimeUpdate);
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
      };
    }

    return () => {
    }
  }, [
    handleUserEventPlayingTrack,
    peaksInstance,
    audioAdapter,
    currentTrack,
    mediaState
  ]);
};

export default useUserEventPlayingTrack;
